import { QueryKey } from '@gogame/query';

export const FAVORITES = 'favorites';
const favoritesQuery = new QueryKey(FAVORITES);

export const favorites = () => favoritesQuery.all();

const MUTATION_SAVE = 'saveFavorites';

export const mutations = favoritesQuery.mutations();

export const save = mutations.mutate(MUTATION_SAVE);
